import React from "react";

import { ZeosFontSize } from "../../services/helpers/ThemeHelpers";

interface IProps {
  label: string;
  htmlFor?: string;
  required?: boolean;
}

export const ZeosLabel = (props: IProps) => {
  const { label, htmlFor, required = false } = props;
  return (
    <label
      htmlFor={htmlFor}
      className={`block text-${ZeosFontSize.lg} text-zeos-black mb-2 font-sans`}
    >
      {label}
      {required && <span className="text-zeos-orange-dk">*</span>}
    </label>
  );
};
